import Default from './Default';
import Home from './Home';
import Intro from './Intro';

const FixasDefault = Default;

export default FixasDefault;
export const FixasHome = Home;
export const FixasIntro = Intro;
